import React, { useState } from "react";
import useOverviewContext from "../../store/use-overview-context";
import { useDebounce } from "react-use";

const SearchInput = ({ onSubmit = () => {} }) => {
  const { searchQueryString, setSearchQueryString } = useOverviewContext();

  const [input, setInput] = useState(searchQueryString);

  useDebounce(
    () => {
      if (input !== searchQueryString) {
        setSearchQueryString(input);
      }
    },
    500,
    [input]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(input); // Pass the current input value
  }

  return (
    <div className="filter-string">
      <input
        type="search"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit(e);
          }
        }}
        placeholder="Search"
      />
    </div>
  );
};

SearchInput.propTypes = {};

export default SearchInput;
